import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import Container from './Container';
import Paper from './Paper';

function AppForm({ children }) {
  return (
    <Box
      sx={{
        display: 'flex',
        backgroundImage: 'url(/static/onepirate/appCurvyLines.png)',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Container maxWidth="sm">
        <Box pt={3} pb={7}>
          <Paper
            sx={(theme) => ({
              padding: theme.spacing(4, 3),
              [theme.breakpoints.up('md')]: {
                padding: theme.spacing(8, 6),
              },
            })}
          >
            {children}
          </Paper>
        </Box>
      </Container>
    </Box>
  );
}

AppForm.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppForm;
